import React from 'react'
import {CreateGuesser} from '@api-platform/admin'
import {TextInput, BooleanInput} from 'react-admin';
import {useTranslation} from "react-i18next";


function Create(props) {
    const {t} = useTranslation()

    return (
        <CreateGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <TextInput source="code" label={t('admin.code')}/>
            <BooleanInput source="isBriefManyProducts" label={t('admin.isBriefManyProducts')}/>
        </CreateGuesser>
    )
}

export default Create
